import './search.css'
import React from 'react';


const SearchBar = ({searchQuery, setSearchQuery}) => (



    <div className="search">      
        <input
            value = {searchQuery}
            onInput = {e => setSearchQuery(e.target.value)}
            type = "text"
            placeholder = " Search..."
            name = "search"
            />
            <div className = "inSearch" onClick={e=>setSearchQuery("")}></div>
    </div>
);

export default SearchBar;